module.exports = __webpack_public_path__ + "static/media/timer.1ac86b66.gif";